export default import.meta.ROLLDOWN_FILE_URL_wQrPQCeOvi$zO8dTE6SWlA